import Markdown from "components/Markdown";

const example_prompt = `\`\`\`\`markdown
Namespace: sqlite://dronedeploy.db

Name: dronedeploy.plans

Technical Owner: ben.pyrik@vylor.com

Business Owner: justin.gruca@vylor.com

Producer: https://gitlab.research.vylor.com/research/field-operations-tools/drone-deploy-ingestion

Description: This dataset represents the "plans" table of the dronedeploy SQLite database. The "plans" table contains all metadata pulled from Drone Deploy's /plans REST API endpoint.

Schema: Here is the SQL statement used to create the plans table:

\`\`\`sql
CREATE TABLE plans (
id TEXT PRIMARY KEY,
status TEXT NOT NULL,
name TEXT,
log TEXT,
latest_started_map TEXT,
location TEXT,
geometry TEXT,
date_creation INTEGER,
image_count INTEGER,
latest_image_transfer_id TEXT,
share_links TEXT,
account TEXT,
extra TEXT,
corteva_is_map_plan BOOLEAN
)
\`\`\`

Here are the first three rows (this is not a representative sample):

\`\`\`sql
INSERT INTO "main"."plans" ("id", "status", "name", "log", "latest_started_map", "location", "geometry", "date_creation", "image_count", "latest_image_transfer_id", "share_links", "account", "extra", "corteva_is_map_plan") VALUES ('6336297b5cc1cb7db8a582cd', 'new', 'Map Plan', 'ede726e1c0_F4BD7FA35DINSPIRE', '{"user_status":"New"}', '{"lat":16.174279879159414,"lng":-93.28074609674513}', '[{"lat":16.174881738927695,"lng":-93.28056190162897},{"lat":16.174453735351562,"lng":-93.28009033203125},{"lat":16.17367172241211,"lng":-93.28094482421875},{"lat":16.17411231994629,"lng":-93.28138732910156}]', 1664493947252, 0, NULL, '{"public":"https://www.dronedeploy.com/app2/data/6336297b5cc1cb7db8a582cd?jwt_token=eyJ..."}', 'old', '{}', NULL);
INSERT INTO "main"."plans" ("id", "status", "name", "log", "latest_started_map", "location", "geometry", "date_creation", "image_count", "latest_image_transfer_id", "share_links", "account", "extra", "corteva_is_map_plan") VALUES ('633b62ed310fd57e115ec332', 'new', 'Map Plan', 'ae57eefbd7_72BB0A762BINSPIRE', '{"user_status":"New"}', '{"lat":42.84506492135796,"lng":-113.10627666674554}', '[{"lat":42.846588134765625,"lng":-113.10165405273438},{"lat":42.84366226196289,"lng":-113.10163116455078},{"lat":42.84236526489258,"lng":-113.10272979736328},{"lat":42.8416633605957,"lng":-113.1045150756836},{"lat":42.841651916503906,"lng":-113.10787200927734},{"lat":42.84248733520508,"lng":-113.10950469970703},{"lat":42.84366989135742,"lng":-113.11062622070312},{"lat":42.84632110595703,"lng":-113.11072540283203},{"lat":42.84756088256836,"lng":-113.1098861694336},{"lat":42.848487854003906,"lng":-113.1083984375},{"lat":42.8485107421875,"lng":-113.10477447509766},{"lat":42.84781030629546,"lng":-113.10300249606371}]', 1664836333307, 0, NULL, '{"public":"https://www.dronedeploy.com/app2/data/633b62ed310fd57e115ec332?jwt_token=eyJ..."}', 'old', '{}', NULL);
INSERT INTO "main"."plans" ("id", "status", "name", "log", "latest_started_map", "location", "geometry", "date_creation", "image_count", "latest_image_transfer_id", "share_links", "account", "extra", "corteva_is_map_plan") VALUES ('633b68d4310fd57e115ec48a', 'new', 'Map Plan', '54329cee80_72BB0A762BINSPIRE', '{"user_status":"New"}', '{"lat":42.83829852513961,"lng":-113.10617146578927}', '[{"lat":42.8416862487793,"lng":-113.10499572753906},{"lat":42.840850830078125,"lng":-113.102783203125},{"lat":42.8394889831543,"lng":-113.1015625},{"lat":42.83695983886719,"lng":-113.10152435302734},{"lat":42.835723876953125,"lng":-113.10236358642578},{"lat":42.83494186401367,"lng":-113.10450744628906},{"lat":42.83485794067383,"lng":-113.10794830322266},{"lat":42.835697719155746,"lng":-113.10968991369009},{"lat":42.83728790283203,"lng":-113.11078643798828},{"lat":42.83958435058594,"lng":-113.11080169677734},{"lat":42.84083557128906,"lng":-113.10942840576172},{"lat":42.84166717529297,"lng":-113.107666015625}]', 1664837844943, 0, NULL, '{"public":"https://www.dronedeploy.com/app2/data/633b68d4310fd57e115ec48a?jwt_token=eyJ..."}', 'commercial', '{}', NULL);
\`\`\`
\`\`\`\`
`;

const renderedContent = <Markdown content={example_prompt} />;

export default function Introduction() {
  return (
    <div className="center measure-wide pa2 pa0-ns">
      <p className="f5 lh-copy measure">
        The <span className="i">Dataset Creator</span> is an experiment to help
        users of the Galileo data catalog create datasets.
      </p>

      <p className="f5 lh-copy measure">
        Users provide a plaintext dump of information about their dataset:
      </p>

      {renderedContent}

      <p className="f5 lh-copy measure">
        And receive an OpenLineage dataset event in JSON format.
      </p>

      <p className="f5 lh-copy measure b">Limitations</p>
      <p className="f5 lh-copy measure">
        The system prompt is static and may contain outdated information. Not
        all facets are supported.
      </p>
    </div>
  );
}
